import ValidationService from './validation.service';

export default ValidationService;
